import { TableCell, TableRow } from "@/components/_ui/table";
import { Row, RowData } from "@tanstack/react-table";

import { isRawRow, SectionData } from "../datatable-types";
import { useDatatableContext } from "../use-datatable-context";

interface DatatableListSectionRowProps<TData extends RowData> {
  row: Row<SectionData<TData>>;
}

export function DatatableListSectionRow<TData extends RowData>({ row }: DatatableListSectionRowProps<TData>) {
  const renderSectionHeader = row.original.column.renderSectionHeader;
  const { table } = useDatatableContext<TData>();

  const rowModel = table.getFilteredRowModel();
  const filteredRows = rowModel.flatRows.filter((flatRow) => {
    if (!isRawRow(flatRow.original)) {
      return false;
    }
    return row.original.key === row.original.getSectionKey(flatRow.original);
  });

  const count = filteredRows.length;

  if (!count) {
    return null;
  }

  if (!renderSectionHeader) {
    return null;
  }

  return (
    <TableRow
      key={row.id}
      data-state={row.getIsSelected() && "selected"}
      className="border-b border-t p-0 text-xs first:border-t-0 "
      data-testid={"datatable-list-section-row"}
    >
      <TableCell colSpan={row.getVisibleCells().length} className="h-8 p-0">
        {renderSectionHeader(row.original, row)}
      </TableCell>
    </TableRow>
  );
}
